module.exports = __webpack_public_path__ + "img/symbol_3.9b6b9d6e.png";